import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import AppShell from "@/components/AppShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const { login, loading } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      const user = await login(email.trim().toLowerCase(), password);
      toast.success(`Signed in as ${user.name}`);
      const to = loc.state?.from || (user.is_admin ? "/admin" : "/supervisor");
      nav(to, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign in failed");
    }
  };

  return (
    <AppShell>
      <section className="max-w-[520px] mx-auto px-5 sm:px-8 py-14 sm:py-20">
        <div className="pnc-eyebrow mb-4">PNC · Staff Access</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[#F5F5F5] tracking-tight leading-[1.05] mb-3">
          Staff sign in
        </h1>
        <p className="text-[#A8A8A8] mb-10">For supervisors and the main manager.</p>

        <div className="pnc-card p-6 sm:p-8">
          <form className="space-y-5" onSubmit={submit} data-testid="login-form">
            <div className="space-y-2">
              <Label className="pnc-eyebrow">Email</Label>
              <Input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="h-12 sm:h-14 bg-[#1E1E1E] border-[#2A2A2A] text-[#F5F5F5] placeholder:text-[#6B6B6B] focus-visible:ring-2 focus-visible:ring-[#C0C0C0]/20 focus-visible:border-[#C0C0C0]"
              />
            </div>
            <div className="space-y-2">
              <Label className="pnc-eyebrow">Password</Label>
              <Input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="h-12 sm:h-14 bg-[#1E1E1E] border-[#2A2A2A] text-[#F5F5F5] placeholder:text-[#6B6B6B] focus-visible:ring-2 focus-visible:ring-[#C0C0C0]/20 focus-visible:border-[#C0C0C0]"
              />
            </div>
            <Button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full gap-2 h-12 sm:h-14 rounded-xl bg-[#C0C0C0] hover:bg-[#8A8A8A] text-[#0A0A0A] font-medium"
            >
              <LogIn className="w-4 h-4" strokeWidth={2}/> {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </div>

        <Link to="/request" className="block mt-8 text-sm text-[#C0C0C0] hover:text-[#F5F5F5] text-center underline underline-offset-4">
          Or submit an absence notification →
        </Link>
      </section>
    </AppShell>
  );
}
